import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { InstanceModule } from './instance-module';
import { RoleType } from './module-role';

interface IProfile {
	id: number;
	login: string;
	userName: string;
	firstName: string;
	lastName: string;
	mail: string;
	primaryOrganizationId: number;
	accounts: Map<number, Array<RoleType>>;
	availableInstanceModules: Map<number, InstanceModule>;
}

const entityDefaults: IProfile = {
	id: -1,
	firstName: '',
	lastName: '',
	userName: '',
	login: '',
	mail: '',
	primaryOrganizationId: -1,
	accounts: Map(),
	availableInstanceModules: Map(),
};

export class UserProfile implements IProfile {
	private [immerable] = true;
	public id = entityDefaults.id;
	public login = entityDefaults.login;
	public firstName = entityDefaults.firstName;
	public lastName = entityDefaults.lastName;
	public userName = entityDefaults.userName;
	public mail = entityDefaults.mail;
	public primaryOrganizationId = entityDefaults.primaryOrganizationId;
	public accounts = entityDefaults.accounts;
	public availableInstanceModules = entityDefaults.availableInstanceModules;

	public static build(params: Partial<IProfile> = {}): UserProfile {
		const inst = new UserProfile();
		inst.id = params.id ?? entityDefaults.id;
		inst.login = params.login ?? entityDefaults.login;
		inst.firstName = params.firstName ?? entityDefaults.firstName;
		inst.lastName = params.lastName ?? entityDefaults.lastName;
		inst.mail = params.mail ?? entityDefaults.mail;
		inst.primaryOrganizationId =
			params.primaryOrganizationId ?? entityDefaults.primaryOrganizationId;
		inst.accounts = params.accounts ?? entityDefaults.accounts;
		inst.userName = params.userName ?? entityDefaults.userName;
		inst.availableInstanceModules =
			params.availableInstanceModules ??
			entityDefaults.availableInstanceModules;
		return inst;
	}

	public setAvailableInstanceModules(
		instances: Map<number, InstanceModule>,
	): UserProfile {
		return produce(this, (draft: UserProfile) => {
			draft.availableInstanceModules = instances;
		});
	}
}
